import { Button } from "@/components/ui/button";
import { Database, Clock } from "lucide-react";
import { formatImportTimestamp } from "@/hooks/use-import-persistence";
import { Badge } from "@/components/ui/badge";

interface LoadSavedDataButtonProps {
  importedAt: string | null;
  onLoad: () => void;
  loading?: boolean;
  label?: string;
}

export function LoadSavedDataButton({
  importedAt,
  onLoad,
  loading = false,
  label = "Load Last Analysis"
}: LoadSavedDataButtonProps) {
  if (!importedAt) return null;

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 p-3 bg-muted/50 rounded-lg border border-border">
      <div className="flex items-center gap-2 flex-1">
        <Database className="h-5 w-5 text-primary" />
        <div className="flex flex-col">
          <span className="text-sm font-medium text-foreground">Saved Data Available</span>
          <span className="text-xs text-muted-foreground flex items-center gap-1">
            <Clock className="h-3 w-3" />
            {formatImportTimestamp(importedAt)}
          </span>
        </div>
      </div>
      <Button 
        onClick={onLoad} 
        disabled={loading}
        variant="default"
        size="sm"
        className="shrink-0"
      >
        <Database className="h-4 w-4 mr-2" />
        {label}
      </Button>
    </div>
  );
}
